let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lfyv0")).then(() => parcelRequire('jWelK'));